import { Routes, Route } from "react-router-dom";
import "./App.css";
import {
  Signup,
  Login,
  Home,
  Analytics,
  Engagements,
  GenerateAi,
  Scheduling,
  GenerateCaption,
  GenerateContent,
  Profile,
  Instagram,
  Facebook,
  Snapchat,
  Linkedln,
} from "./view/pages/index.js";
import { LandingPage } from "./view/layouts/index.js";
import ForgetPassword from "./view/pages/auth/forgetPassword/ForgetPassword.jsx";
import ResetPassword from "./view/pages/auth/forgetPassword/ResetPassword.jsx";
import PrivateRoute from "./view/routes/PrivateRoute.jsx";
import { DashboardLayout } from "./view/layouts/index.js";

import LogoutButton from "./view/pages/LogoutButton.jsx";
import "./theme.css";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/register" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="fb" element={<LogoutButton />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <DashboardLayout />
            </PrivateRoute>
          }
        >
          <Route path="dashboard" element={<Home />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="scheduling" element={<Scheduling />} />
          <Route path="engagements" element={<Engagements />} />
          <Route path="ai" element={<GenerateAi />} />
          <Route path="caption" element={<GenerateCaption />} />
          <Route path="content" element={<GenerateContent />} />
          <Route path="profile" element={<Profile />} />
          <Route path="insta" element={<Instagram />} />
          <Route path="facebook" element={<Facebook />} />
          <Route path="snapchat" element={<Snapchat />} />
          <Route path="linkedln" element={<Linkedln />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
